var render, staticRenderFns
import script from "./layout-menu.vue?vue&type=script&lang=js"
export * from "./layout-menu.vue?vue&type=script&lang=js"
import style0 from "./layout-menu.vue?vue&type=style&index=0&id=9ad37818&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports